import { Box, TextField } from '@mui/material';
import { useLanguage } from '../../../../../context/LanguageContext';
import { useSyncedInputValue } from './useSyncedInputValue';

interface BetweenEditorProps {
    value: string;
    inputType?: string;
    onChange: (value: string) => void;
    swapIfInverted: boolean;
}

const BOUND_SX = { flex: '1 1 0', minWidth: 80 };

const isInverted = (min: string, max: string): boolean =>
    min !== '' && max !== '' && !Number.isNaN(Number(min)) && !Number.isNaN(Number(max)) && Number(min) > Number(max);

function BetweenEditor({ value, inputType, onChange, swapIfInverted }: BetweenEditorProps) {
    const { t } = useLanguage();
    const [minValue = '', maxValue = ''] = value.split('|');
    const minRef = useSyncedInputValue(minValue);
    const maxRef = useSyncedInputValue(maxValue);

    const handleBlur = () => {
        const min = minRef.current?.value ?? '';
        const max = maxRef.current?.value ?? '';
        onChange(swapIfInverted && isInverted(min, max) ? `${max}|${min}` : `${min}|${max}`);
    };

    const type = inputType === 'date' || inputType === 'number' ? inputType : 'text';
    const inputLabelProps = type === 'date' ? { shrink: true } : undefined;

    return (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', width: '100%' }}>
            <TextField
                inputRef={minRef}
                type={type}
                size="small"
                defaultValue={minValue}
                onBlur={handleBlur}
                placeholder={t('pages.clients.queryBuilder.simple.between.min')}
                sx={BOUND_SX}
                InputLabelProps={inputLabelProps}
            />
            <Box sx={{ px: 1, color: 'text.secondary' }}>{t('pages.clients.queryBuilder.simple.between.and')}</Box>
            <TextField
                inputRef={maxRef}
                type={type}
                size="small"
                defaultValue={maxValue}
                onBlur={handleBlur}
                placeholder={t('pages.clients.queryBuilder.simple.between.max')}
                sx={BOUND_SX}
                InputLabelProps={inputLabelProps}
            />
        </Box>
    );
}

export default BetweenEditor;
